module.exports = __webpack_public_path__ + "img/img-3.d3a84153.png";